import { useTimer } from "@/lib/helpers/useTimer";

export type CountdownProps = {
    target: Date;
    children: (number) => React.Node;
};

export default function Countdown({ target, children }: CountdownProps) {
    const remaining = useTimer(target);
    return children({ remaining });
}
